import React from 'react';
import { DTBContentBlock } from '../../../_types/dtb';
import ContentBlock from './ContentBlock';
import VideoBlock from './VideoBlock';

export interface BlockCommonProps {
  isEditMode: boolean;
  index: number;
  block: DTBContentBlock;
  onSave: (index: number, block: DTBContentBlock) => void;
}

const BlockSelector: React.FC<BlockCommonProps> = (props) => {
  switch (props.block.contentType) {
    case 'CONTENT':
      return (
        <ContentBlock
          block={props.block}
          isEditMode={props.isEditMode}
          index={props.index}
          onSave={props.onSave}
        />
      );
    case 'VIDEO':
      return (
        <VideoBlock
          block={props.block}
          index={props.index}
          onSave={props.onSave}
          isEditMode={props.isEditMode}
        />
      );
    default:
      return null;
  }
};

export default BlockSelector;
